import type {TableConfiguration} from 'schema/table/types';
import type {AgentPerson} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {personAgentDefaultColumns} from './columns';

export const personAgentTableConfig: TableConfiguration<AgentPerson> = {
  ...defaultTableConfig,
  defaultColumns: personAgentDefaultColumns,
};
